export default __webpack_public_path__ + "static/media/arrow-right.aa9660fa.svg";